<template>
  <div class="success-container">
    <div class="success-card">
      
      <div class="success-icon">
        <div class="check-circle">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" fill="#10b981"/>
            <path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
      
      <h1>🎉 支付成功</h1>
      <p class="success-message">您的悦览PRO会员已激活</p>
      
      <!-- VIP状态信息 -->
      <div v-if="vipInfo" class="vip-status-info">
        <div class="status-item">
          <span class="status-label">会员状态：</span>
          <span class="status-value active">{{ vipInfo.is_vip ? '已激活' : '未激活' }}</span>
        </div>
        
        <!-- 永久会员专属ID -->
        <div v-if="isPermanentMember" class="status-item">
          <span class="status-label">永久会员专属ID：</span>
          <span class="status-value permanent-id">{{ formatMemberId(vipInfo.id) }}</span>
        </div>
        
        <!-- 到期时间 -->
        <div class="status-item">
          <span class="status-label">到期时间：</span>
          <span class="status-value expire-time">{{ formatExpireTime(vipInfo.datetime_end) }}</span>
        </div>
      </div>
      
      <!-- 加载状态 -->
      <div v-else-if="loading" class="loading-status">
        <div class="loading-spinner"></div>
        <p>正在获取会员状态...</p>
      </div>
      
      <!-- 错误状态 -->
      <div v-else-if="error" class="error-status">
        <p class="error-message">{{ error }}</p>
      </div>
      
      <div class="support-info">
        <p>如有问题请联系客服</p>
        <p class="contact">service@charactech.cn</p>
      </div>
      
      <!-- 版权信息 -->
      <div class="footer-copyright">
        <p>© 2025 珠海字符科技有限公司 版权所有</p>
        <p><a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">粤ICP备2025361041号</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'PaymentSuccessView',
  data() {
    return {
      paymentTime: new Date().toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      }),
      vipInfo: null,
      loading: true,
      error: null
    }
  },
  computed: {
    planName() {
      return this.$route.query.plan || '悦览PRO套餐'
    },
    amount() {
      return this.$route.query.amount || '0'
    },
    unionId() {
      // 直接从localStorage获取unionID
      return localStorage.getItem('unionId') || ''
    },
    isPermanentMember() {
      if (!this.vipInfo || !this.vipInfo.datetime_end) return false
      const endDate = new Date(this.vipInfo.datetime_end)
      const year2100 = new Date('2100-01-01')
      return endDate > year2100
    }
  },
  async mounted() {
    await this.fetchVipStatus()
  },
  methods: {
    async fetchVipStatus() {
      const unionId = localStorage.getItem('unionId')
      
      if (!unionId) {
        this.error = '未找到用户ID，请重新购买'
        this.loading = false
        return
      }

      try {
        this.loading = true
        const response = await axios.post('https://api.charactech.cn/yuelan/uservip/get_vip_status', {
          unionID: unionId
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        })

        if (response.data && response.data.success) {
          this.vipInfo = response.data.data
        } else {
          this.error = response.data?.message || '获取会员状态失败'
        }
      } catch (error) {
        console.error('获取VIP状态失败:', error)
        this.error = '网络错误，无法获取会员状态'
      } finally {
        this.loading = false
      }
    },
    
    formatMemberId(id) {
      if (!id) return '----'
      return String(id).padStart(4, '0')
    },
    
    formatExpireTime(datetime) {
      if (!datetime) return '未知'
      
      const date = new Date(datetime)
      const year2100 = new Date('2100-01-01')
      
      if (date > year2100) {
        return '永久有效'
      }
      
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    
    goToApp() {
      alert('即将打开悦览应用...')
    },
    goHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.success-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.success-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 48px 32px;
  max-width: 420px;
  width: 100%;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.logo-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 32px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(16, 185, 129, 0.1);
}

.brand-name {
  font-size: 1.5rem;
  font-weight: 700;
  color: #10b981;
}

.success-icon {
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
}

.check-circle {
  animation: successPulse 0.6s ease-out;
}

@keyframes successPulse {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.success-card h1 {
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 12px 0;
}

.success-message {
  font-size: 1.125rem;
  color: #64748b;
  margin: 0 0 32px 0;
  font-weight: 500;
}

/* VIP状态信息样式 */
.vip-status-info {
  background: linear-gradient(135deg, #f0fdf4, #ecfdf5);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 32px;
  border: 1px solid rgba(16, 185, 129, 0.1);
}

.status-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.status-item:last-child {
  margin-bottom: 0;
}

.status-label {
  font-size: 0.875rem;
  color: #64748b;
  font-weight: 500;
}

.status-value {
  font-size: 0.875rem;
  color: #1e293b;
  font-weight: 600;
}

.status-value.active {
  color: #10b981;
  font-weight: 700;
}

.status-value.permanent-id {
  font-size: 1rem;
  color: #7c3aed;
  font-weight: 700;
  font-family: 'Courier New', monospace;
  background: rgba(124, 58, 237, 0.1);
  padding: 4px 8px;
  border-radius: 6px;
}

.status-value.expire-time {
  color: #059669;
  font-weight: 600;
}

/* 加载状态样式 */
.loading-status {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 32px;
  padding: 24px;
}

.loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e2e8f0;
  border-top: 3px solid #10b981;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-status p {
  font-size: 0.875rem;
  color: #64748b;
  margin: 0;
}

/* 错误状态样式 */
.error-status {
  background: linear-gradient(135deg, #fef2f2, #fee2e2);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 32px;
  border: 1px solid rgba(239, 68, 68, 0.1);
}

.error-message {
  font-size: 0.875rem;
  color: #dc2626;
  margin: 0;
  font-weight: 500;
}

.order-info {
  background: linear-gradient(135deg, #f0fdf4, #ecfdf5);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 32px;
  border: 1px solid rgba(16, 185, 129, 0.1);
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.label {
  font-size: 0.875rem;
  color: #64748b;
  font-weight: 500;
}

.value {
  font-size: 0.875rem;
  color: #1e293b;
  font-weight: 600;
}

.value.price {
  font-size: 1.125rem;
  color: #10b981;
  font-weight: 700;
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 32px;
}

.primary-btn {
  width: 100%;
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  border: none;
  padding: 16px 24px;
  border-radius: 12px;
  font-size: 1.125rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(16, 185, 129, 0.3);
}

.primary-btn:hover {
  background: linear-gradient(135deg, #059669, #047857);
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(16, 185, 129, 0.4);
}

.secondary-btn {
  width: 100%;
  background: rgba(16, 185, 129, 0.1);
  color: #059669;
  border: 2px solid rgba(16, 185, 129, 0.2);
  padding: 14px 24px;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.secondary-btn:hover {
  background: rgba(16, 185, 129, 0.2);
  border-color: rgba(16, 185, 129, 0.3);
  transform: translateY(-1px);
}

.support-info {
  margin-bottom: 24px;
}

.support-info p {
  margin: 4px 0;
  font-size: 0.875rem;
  color: #64748b;
}

.contact {
  color: #10b981 !important;
  font-weight: 600;
}

.footer-copyright {
  text-align: center;
  padding-top: 16px;
  border-top: 1px solid rgba(16, 185, 129, 0.1);
  font-size: 0.75rem;
  color: #64748b;
  line-height: 1.5;
}

.footer-copyright p {
  margin: 2px 0;
}

.footer-copyright a {
  color: #10b981;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-copyright a:hover {
  color: #059669;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .success-container {
    padding: 16px;
  }
  
  .success-card {
    padding: 32px 24px;
  }
  
  .success-card h1 {
    font-size: 1.75rem;
  }
  
  .success-message {
    font-size: 1rem;
  }
  
  .status-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  
  .status-value.permanent-id {
    font-size: 0.875rem;
  }
}

@media (max-width: 480px) {
  .success-card {
    padding: 24px 20px;
  }
  
  .success-card h1 {
    font-size: 1.5rem;
  }
  
  .vip-status-info {
    padding: 20px;
  }
}
</style>